import api from './api';
import type {FinanceOrderBasis} from './finance-source-api';
export type CostCategory='PRODUCT'|'SHIPPING'|'PAYMENT'|'RETURN';
export interface CostProductUnit {lineRef:string;unitFrom:number;unitThrough:number;unitCost:string}
export interface CostDocumentInput {
  storeId:string;orderId:string;kind:'CHARGE'|'RECOVERY';category:CostCategory;sourceAccountRef:string;sourceLineRef:string;
  componentRef:string;currency:string;basis:'NET'|'GROSS';amount:string;occurredAt:string;evidenceRef:string;
  ruleSnapshotId:string|null;shipmentId:string|null;paymentRef:string|null;productBasisRevisionId:string|null;
  productUnits:CostProductUnit[];recoverableUnitsEvidenceRef:string|null;chargeId:string|null;
}
export interface CostDocumentEntry {
  document:{id:string;tenantId:string;storeId:string;orderId:string;ordinal:number;previousLineId:string|null;recordedAt:string;contentHash:string;quality:'ADMIN_DOCUMENT_LINE'};
  body:CostDocumentInput;latest:boolean;
}
export interface CostDocumentHistory {
  tenantId:string;storeId:string;orderId:string;knowledgeAsOf:string;documents:CostDocumentEntry[];selectedDocumentId:string|null;
  reconciliation:{status:'UNAVAILABLE';reason:string}|{status:'READ';result:{buckets:Array<{currency:string;basis:'NET'|'GROSS';knownDocumentNet:string;confirmedTotal:null;costCoverage:'UNAVAILABLE'}>}};
}
export interface CostDocumentContext extends CostDocumentHistory {
  currency:string;shipments:Array<{id:string;carrier:string}>;
  basis:{sourceRevisionId:string;recordedAt:string;source:Extract<FinanceOrderBasis,{status:'READ'}>['basis']}|null;
}
export type CostDocumentWrite=Omit<CostDocumentInput,'orderId'> & {acquisitionKey:string;previousLineId:string|null};
export const financeCostDocumentApi={
  context:(storeId:string,orderId:string,sourceRevisionId?:string)=>api.get<CostDocumentContext>(`/finance/orders/${encodeURIComponent(orderId)}/cost-document-context`,{params:{storeId,sourceRevisionId}}),
  history:(storeId:string,orderId:string,knowledgeAsOf?:string)=>api.get<CostDocumentHistory>(`/finance/orders/${encodeURIComponent(orderId)}/cost-documents`,{params:{storeId,knowledgeAsOf}}),
  write:(orderId:string,input:CostDocumentWrite)=>api.post<Omit<CostDocumentEntry,'latest'>&{replayed:boolean}>(`/finance/orders/${encodeURIComponent(orderId)}/cost-documents`,input),
};
